<template>
  <b-alert class="m-alert" :show="show" @dismissed="emits('dismissed', $event)" :variant="variant">
    <div class="m-alert-icon" v-if="withIcon">
      <Icon :icon="getIcon()" size="16px"></Icon>
    </div>
    <div class="m-alert-content">
      <slot></slot>
    </div>
    <div class="m-alert-close-button" v-if="dismissible" @click="emits('dismissed', $event)">
      <Icon icon="Close" size="16px"></Icon>
    </div>
  </b-alert>
</template>

<script setup lang="ts">
import { ColorVariants } from "@medapro-types/common/common";
import Icon from "./Icon.vue";

const emits = defineEmits(["dismissed"]);

const props = withDefaults(defineProps<{ variant?: ColorVariants; show?: boolean; dismissible?: boolean; withIcon?: boolean }>(), {
  variant: "info"
});

const getIcon = () => {
  switch (props.variant) {
    case "warning":
      return "Warning1";
    case "danger":
      return "WatcherWarning";
    case "success":
      return "CheckCircle";
    default:
      return "Info";
  }
};
</script>
